module.exports = __webpack_public_path__ + "img/green3.9f867094.svg";